import { render, staticRenderFns } from "./formLabelTag.vue?vue&type=template&id=c3290946&"
import script from "./formLabelTag.vue?vue&type=script&lang=js&"
export * from "./formLabelTag.vue?vue&type=script&lang=js&"
import style0 from "./formLabelTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports